module.exports = __webpack_public_path__ + "img/user_1.c993c33d.png";